export default __webpack_public_path__ + "static/media/avtalegiro.91a76318.jpeg";